import React from 'react';
import Img from 'gatsby-image';

import styles from './CoverPlayable.module.scss';
import play from '../images/play.svg';

const CoverPlayable = ({ img, spotifyPlaylist }) => {
  const [isFlipped, setIsFlipped] = React.useState(false);
  const playlistIsPresent =
    spotifyPlaylist !== undefined &&
    spotifyPlaylist != null &&
    spotifyPlaylist !== '';

  const image =
    typeof img === 'string' || img instanceof String ? (
      <img className={styles.image} src={img} />
    ) : (
      <Img fluid={img.childImageSharp.fluid} className={styles.image} />
    );

  return (
    <div className={styles.container}>
      <div
        className={`${styles.cover} ${isFlipped ? styles.normal : ''}`}
        onClick={() => {
          if (playlistIsPresent) setIsFlipped(true);
        }}
      >
        {image}
        {/* {playlistIsPresent && <img src={play} className={styles.coverPlay} />} */}
      </div>
      {/* {playlistIsPresent && (
        <div className={`${styles.back} ${isFlipped ? styles.visible : ''}`}>
          <iframe
            src={spotifyPlaylist}
            width="300"
            height="300"
            frameBorder="0"
            allowtransparency="true"
            title="playlist"
            allow="encrypted-media"
          />
        </div>
      )} */}
    </div>
  );
};

export default CoverPlayable;
